var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "1200px", margin: "auto", padding: "20px" } },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phone,
            expression: "phone"
          }
        ],
        domProps: { value: _vm.phone },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.phone = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("ge-code", {
        ref: "geCode",
        staticClass: "btn",
        attrs: { config: _vm.config }
      }),
      _vm._v(" "),
      _c("button", { on: { click: _vm.closeCode } }, [
        _vm._v("\n\t\t\t关闭倒计时\n\t\t")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm._l(10, function(i) {
        return _c(
          "div",
          {
            staticClass: "btn",
            style: {
              margin: "10px",
              background: "hsla(" + i * 10 + ", 100%, 40%, 2)"
            }
          },
          [_c("ge-code")],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }